import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <a
      href="#top"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg shadow-foreground-950/15 transition-colors hover:bg-primary-600"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </a>
  );
}